/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Deck_No_CardsInputs */



/**
* | output |
* | --- |
* | "No cards found in deck list" |
*
* @param {Err_Deck_No_CardsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_deck_no_cards = /** @type {((inputs?: Err_Deck_No_CardsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Deck_No_CardsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune carte trouvée dans la liste du deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron cartas en la lista del mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma carta encontrada na lista do deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna carta trovata nella lista del deck")
	return /** @type {LocalizedString} */ ("No cards found in deck list")
});